import { defineCustomElements } from '@uefadigital/panenka/dist/loader';

defineCustomElements();
